let apidaePresta = {
    delimiters: ['%%', '%%'],
    props: {
        type: String,
        prestaItem: Object, 
        lang: String,
        showDate: Number,
        showTarif: Number
    },
    template: `
        <div class="PrestaItem item single-item" v-if="prestaItem.prestaVO">
            <div class="PrestaItem-mainContent main-content single-item">
                <div class="main-headline">
                    <div class="content">
                        <div class="Presta-title">
                            <div class="date" v-if="showDate">
                                <div class="date-double" v-if="prestaItem.prestaVO.dateDebut != prestaItem.prestaVO.dateFin">
                                    <div class="dateDebut">
                                        <span class="day">%% prestaItem.prestaVO.dateDebut | formatTimestamp('Do', lang) %%</span>
                                        <span class="month">%% prestaItem.prestaVO.dateDebut | formatTimestamp('MMM', lang) %%</span>
                                        <span class="year">%% prestaItem.prestaVO.dateDebut | formatTimestamp('YY', lang) %%</span>
                                    </div>
                                    <div class="dateFin">
                                        <span class="day">%% prestaItem.prestaVO.dateFin | formatTimestamp('Do', lang) %%</span>
                                        <span class="month">%% prestaItem.prestaVO.dateFin | formatTimestamp('MMM', lang) %%</span>
                                        <span class="year">%% prestaItem.prestaVO.dateFin | formatTimestamp('YY', lang) %%</span>
                                    </div>
                                </div>
                                <div class="date-simple" v-else>
                                    <div class="dateDebut">
                                        <span class="day">%% prestaItem.prestaVO.dateDebut | formatTimestamp('Do', lang) %%</span>
                                        <span class="month">%% prestaItem.prestaVO.dateDebut | formatTimestamp('MMM', lang) %%</span>
                                        <span class="year">%% prestaItem.prestaVO.dateDebut | formatTimestamp('YY', lang) %%</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <span class="category category--full" v-if="prestaItem.prestaVO.categorie">
                                    %% prestaItem.prestaVO.categorie %%
                                    <img :src="prestaItem.prestaVO.pictoClassement.url" :alt="prestaItem.prestaVO.pictoClassement.legende" :title="prestaItem.prestaVO.pictoClassement.legende" v-if="prestaItem.prestaVO.pictoClassement">
                                    à %% prestaItem.commune %%
                                </span>
                                <h1 class="title title--full"><span itemprop="name">%% prestaItem.title %%</span></h1>

                                <p v-html="$options.filters.stripTags(prestaItem.prestaVO.descriptionCourte)"></p>
                            </div>
                        </div>
                        <div class="descriptifsThematises">
                            <fieldset class="fieldset" v-if="prestaItem.prestaVO.complementAccueil">
                                <legend>Complément d'information</legend>
                                <p v-html="$options.filters.stripTags(prestaItem.prestaVO.complementAccueil)"></p>
                            </fieldset>
                            <fieldset class="fieldset" v-for="descriptifThematise in prestaItem.prestaVO.descriptifsThematises" v-if="prestaItem.prestaVO.descriptifsThematises">
                                <legend>%% descriptifThematise.theme %%</legend>
                                <p v-html="$options.filters.stripTags(descriptifThematise.description)"></p>
                            </fieldset>
                        </div>

                        <div class="descriptifs">
                            <div itemprop="description" class="description" v-if="prestaItem.prestaVO.descriptionLongue">
                                <p v-html="$options.filters.stripTags(prestaItem.prestaVO.descriptionLongue)"></p>
                            </div>
                        </div>

                        <a v-bind:href="prestaItem.url" class="button large">Découvrir</a>
                    </div>
                    <aside>
                        <div v-if="prestaItem.prestaVO.images"><img :src="prestaItem.prestaVO.images[0].url" alt="" width="100%" style="vertical-align: bottom"/></div>

                        <div class="complementsInformations">
                            <ul v-if="prestaItem.prestaVO.plan">
                                <li v-for="plan in prestaItem.prestaVO.plan">
                                    <a target="_blank" :type="plan.type" :download="plan.legende" class="button" :href="plan.url">
                                        <i class="fad fa-download"></i> Télécharger le .gpx
                                    </a>
                                </li>
                            </ul>

                            <div class="adresse adresse-full">

                                <div itemprop="address" itemscope itemtype="https://schema.org/PostalAddress" v-if="prestaItem.prestaVO.adresse.raisonSociale || prestaItem.prestaVO.adresse.cpltDistribution || prestaItem.prestaVO.adresse.numNomVoie || prestaItem.prestaVO.adresse.lieuDit || prestaItem.prestaVO.adresse.cp || prestaItem.prestaVO.adresse.ville">
                                    <span itemprop="name" v-if="prestaItem.prestaVO.adresse.raisonSociale">%% prestaItem.prestaVO.adresse.raisonSociale %%</span><br />
                                    <span itemprop="streetAddress" v-if="prestaItem.prestaVO.adresse.cpltDistribution">%% prestaItem.prestaVO.adresse.cpltDistribution %%</span><br />
                                    <span itemprop="streetAddress" v-if="prestaItem.prestaVO.adresse.numNomVoie">%% prestaItem.prestaVO.adresse.numNomVoie %%</span><br />
                                    <span itemprop="streetAddress" v-if="prestaItem.prestaVO.adresse.lieuDit">%% prestaItem.prestaVO.adresse.lieuDit %%</span><br />
                                    <span itemprop="postalCode" v-if="prestaItem.prestaVO.adresse.cp || prestaItem.prestaVO.adresse.ville">%% prestaItem.prestaVO.adresse.cp %%</span> <span itemprop="addressLocality">%% prestaItem.prestaVO.adresse.ville %%</span>
                                </div>

                                <p v-if="prestaItem.prestaVO.geolocalisationCplt">(%% prestaItem.prestaVO.geolocalisationCplt %%)</p>
                            </div>
                            <ul class="coordonnee coordonnee-full" v-if="prestaItem.prestaVO.adresse.coordonnee">

                                <li v-for="tel in prestaItem.prestaVO.adresse.coordonnee.telephones">
                                    <i class="fad fa-phone"></i><span> %% tel %%</span>
                                </li>
                                <li v-for="fax in prestaItem.prestaVO.adresse.coordonnee.faxs">
                                    <i class="fad fa-fax"></i><span> %% fax %%</span>
                                </li>
                                <li v-for="(mail, i) in prestaItem.prestaVO.adresse.coordonnee.mails">
                                    <i class="fad fa-envelope"></i>
                                    <a :id="'event-email-' + i" class="email" :href="'mailto:'+ mail +'?subject=Demande de renseignement'">%% mail %%</a>
                                </li>
                                <li v-for="(site, i) in prestaItem.prestaVO.adresse.coordonnee.sites">
                                    <i class="fad fad fa-external-link"></i>
                                    <a :href="site.url" :id="'event-site-' + i" target="_blank">
                                        %% site.domaine %%
                                    </a>
                                </li>
                                <li v-for="(sitemobile, i) in prestaItem.prestaVO.adresse.coordonnee.sitesmobiles">
                                    <i class="fad fad fa-external-link"></i>
                                    <a :href="sitemobile.url" :id="'event-sitemobile-' + i" target="_blank">
                                        %% sitemobile.domaine %%
                                    </a>
                                </li>
                                <li v-for="shortlyurl in prestaItem.prestaVO.adresse.coordonnee.shortlyurls">
                                    <i class="fad fad fa-external-link"></i>
                                    <a :href="shortlyurl.url" :id="'event-shortlyurl-' + i" target="_blank">
                                        %% shortlyurl.domaine %%
                                    </a>
                                </li>
                                <li v-if="prestaItem.prestaVO.adresse.coordonnee.facebooks || prestaItem.prestaVO.adresse.coordonnee.twitters || prestaItem.prestaVO.adresse.coordonnee.yelps">
                                    <a :href="facebook" :id="'event-facebook-' + i" target="_blank" v-for="(facebook, i) in prestaItem.prestaVO.adresse.coordonnee.facebooks">
                                        <i class="fab fa-2x fa-facebook-square"></i>
                                    </a>
                                    <a :href="twitter" :id="'event-twitter-' + i" target="_blank" v-for="(twitter, i) in prestaItem.prestaVO.adresse.coordonnee.twitters">
                                        <i class="fab fa-2x fa-twitter-square"></i>
                                    </a>
                                    <a :href="yelp" :id="'event-yelp-' + i" target="_blank" v-for="(yelp, i) in prestaItem.prestaVO.adresse.coordonnee.yelps">
                                        <i class="fab fa-2x fa-yelp"></i>
                                    </a>
                                </li>
                            </ul>

                            <div class="booking" v-if="prestaItem.prestaVO.tarifsDisplayN || prestaItem.prestaVO.tarifsN || (prestaItem.prestaVO.urlResa && prestaItem.prestaVO.urlResa.url) || prestaItem.prestaVO.cpltResa">
                                
                                <div class="tarifs" v-if="showTarif">
                                    <div itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer" class="hidden" v-if="prestaItem.tarifMin !== null && prestaItem.tarifMax !== null">
                                        <span itemprop="lowPrice">%% prestaItem.tarifMin %%€</span>
                                        to <span itemprop="highPrice">%% prestaItem.tarifMax %%€</span>
                                        <div itemprop="offers" itemscope itemtype="https://schema.org/Offer">
                                            <span itemprop="price">%% prestaItem.tarifMin %%</span>
                                            <span itemprop="priceCurrency">EUR</span>
                                            <link itemprop="availability" href="https://schema.org/InStock" />
                                        </div>
                                        <div itemprop="offers" itemscope itemtype="https://schema.org/Offer">
                                            <span itemprop="price">%% prestaItem.tarifMax %%</span>
                                            <span itemprop="priceCurrency">EUR</span>
                                            <link itemprop="availability" href="https://schema.org/InStock" />
                                        </div>
                                    </div>
 
                                    <div v-if="prestaItem.prestaVO.tarifsDisplayN">
                                        <div class="h2">Tarifs</div>
                                        <p>%% prestaItem.prestaVO.tarifsDisplayN %%</p>
                                    </div>

                                    <div class="leTarifComprend" v-if="prestaItem.prestaVO.leTarifComprend || prestaItem.prestaVO.leTarifNeComprendPas" v-html="$options.filters.stripTags(prestaItem.prestaVO.descriptionLongue)">
                                        <fieldset v-if="prestaItem.prestaVO.leTarifComprend">
                                            <legend><strong>leTarifComprend</strong></legend>
                                            <p v-html="$options.filters.stripTags(prestaItem.prestaVO.leTarifComprend)"></p>
                                        </fieldset>
                                        <fieldset v-if="prestaItem.prestaVO.leTarifNeComprendPas">
                                            <legend><strong>leTarifNeComprendPas</strong></legend>
                                            <p v-html="$options.filters.stripTags(prestaItem.prestaVO.leTarifNeComprendPas)"></p>
                                        </fieldset>
                                    </div>
                                    <p v-if="prestaItem.prestaVO.cpltTarifs !== null" v-html="$options.filters.stripTags(prestaItem.prestaVO.cpltTarifs)"></p>
                                </div>

                                <div class="reservation reservation-full " v-if="prestaItem.prestaVO.reservation !== null">
                                    <div class="callout" v-for="reservation in prestaItem.prestaVO.reservation">
                                        <div class="text-uppercase" v-if="reservation.type">Réservation %% reservation.type %%</div>
                                        <ul class="coordonnee coordonnee-full" v-if="reservation.coordonnee">
                                            <li v-for="tel in reservation.coordonnee.telephones">
                                                <i class="fad fa-phone"></i><span> %% tel %%</span>
                                            </li>
                                            <li v-for="fax in reservation.coordonnee.faxs">
                                                <i class="fad fa-fax"></i><span> %% fax %%</span>
                                            </li>
                                            <li v-for="(mail, i) in reservation.coordonnee.mails">
                                                <i class="fad fa-envelope"></i>
                                                <a :id="'event-email-' + i" class="email" :href="'mailto:'+ mail +'?subject=Demande de renseignement'">%% mail %%</a>
                                            </li>
                                            <li v-for="(site, i) in reservation.coordonnee.sites">
                                                <i class="fad fad fa-external-link"></i>
                                                <a :href="site.url" :id="'event-site-' + i" target="_blank">
                                                    %% site.domaine %%
                                                </a>
                                            </li>
                                            <li v-for="(sitemobile, i) in reservation.coordonnee.sitesmobiles">
                                                <i class="fad fad fa-external-link"></i>
                                                <a :href="sitemobile.url" :id="'event-sitemobile-' + i" target="_blank">
                                                    %% sitemobile.domaine %%
                                                </a>
                                            </li>
                                            <li v-for="(shortlyurl, i) in reservation.coordonnee.shortlyurls">
                                                <i class="fad fad fa-external-link"></i>
                                                <a :href="shortlyurl.url" :id="'event-shortlyurl-' + i" target="_blank">
                                                    %% shortlyurl.domaine %%
                                                </a>
                                            </li>
                                            <li v-if="reservation.coordonnee.facebooks || reservation.coordonnee.twitters || reservation.coordonnee.yelps">
                                                <a :href="facebook" :id="'event-facebook-' + i" target="_blank" v-for="(facebook, i) in reservation.coordonnee.facebooks">
                                                    <i class="fab fa-2x fa-facebook-square"></i>
                                                </a>
                                                <a :href="twitter" :id="'event-twitter-' + i" target="_blank" v-for="(twitter, i) in reservation.coordonnee.twitters">
                                                    <i class="fab fa-2x fa-twitter-square"></i>
                                                </a>
                                                <a :href="yelp" :id="'event-yelp-' + i" target="_blank" v-for="(yelp, i) in reservation.coordonnee.yelps">
                                                    <i class="fab fa-2x fa-yelp"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <p v-if="prestaItem.prestaVO.cpltResa">%% prestaItem.prestaVO.cpltResa %%</p>
                                </div>

                                <div class="ouverture" v-if="showDate">
                                    <div class="h2">Dates</div>
                                    <p v-if="prestaItem.prestaVO.ouvertureN">%% prestaItem.prestaVO.ouvertureN %%</p>
                                    <p v-else-if="prestaItem.prestaVO.ouvertureDisplayN">%% prestaItem.prestaVO.ouvertureDisplayN %%</p>
                                </div>
                            </div>
                        </div>
                    </aside>
                </div>
            </div>
            
        </div>`
  };

  if (document.querySelector('.prestaItem')) {
    document.querySelectorAll('.prestaItem').forEach(p => {
        let id = p.getAttribute('id');
        let prestaId = p.dataset.id;
        let type = p.dataset.type;
        let lang = p.dataset.lang;
        let showDate = parseInt(p.dataset.showdate);
        let showTarif = parseInt(p.dataset.showtarif);
        // console.log(nb);
        new Vue({
            delimiters: ['%%', '%%'],
            el: '#' + id,
            components: { 
                apidaePresta
            },
            data: function () {
                return {
                    loading: true,
                    type: type,
                    prestaItem: {},
                    lang: lang,
                    showDate: showDate,
                    showTarif: showTarif
                }
            },
            mounted: function() {
                fetch(apidae.base_url + '/services/getPrestaItem?idPrestation=' + prestaId + '&feed=json')
                .then(stream => stream.json())
                .then(data => {
                    this.prestaItem = data.item;
                    // console.log(this.prestaItem);

                    this.loading = false;
                })
                .catch(error => console.error(error))
            }
        });
    });
}